import { useState, useEffect } from 'react';

/**
 * PWA standalone 모드인지 감지한다.
 * - display-mode: standalone (manifest 기반 설치)
 * - navigator.standalone (iOS Safari 홈화면 추가)
 */
export function useIsStandalone(): boolean {
  const [isStandalone, setIsStandalone] = useState(() => checkStandalone());

  useEffect(() => {
    const mql = window.matchMedia('(display-mode: standalone)');
    const handler = (e: MediaQueryListEvent) => setIsStandalone(e.matches || checkStandalone());
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isStandalone;
}

function checkStandalone(): boolean {
  // 개발 환경에서는 항상 standalone으로 취급 (설치 권유 Toast가 dev에서 거슬리지 않도록)
  if (import.meta.env.DEV) return true;
  if (window.matchMedia('(display-mode: standalone)').matches) return true;
  if ((navigator as any).standalone === true) return true;
  return false;
}
